var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["header/search-icon-asset.j2"] = require( "header/search-icon-asset.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/search-icon.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<a href=\"#u-search-anchor\" rel=\"nofollow\" class=\"c-site-search__a js-site-search-toggle\" aria-label=\"";
output += runtime.suppressValue((lineno = 0, colno = 103, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["search-form-aria"])), env.opts.autoescape);
output += "\" aria-controls=\"u-search-anchor\" aria-expanded=\"false\" data-qa-search-toggle>\n\n    ";
env.getTemplate("header/search-icon-asset.j2", false, "core/templates/header/search-icon.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n</a>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/search-icon.j2"] , dependencies)